'use client';

import { c as _c } from "react/compiler-runtime";
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import whiteboxNew from '@images/renders/bg_images/whiteboxNew.webp';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useViewport } from '@lib/tools/hooks/useViewport';
import style from './FinishingPoints.module.scss';
export const FinishingPoints = () => {
  const $ = _c(24);
  const {
    isMobile
  } = useViewport();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== isMobile) {
    const finishingPoints = [{
      id: 1,
      text: "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0441\u0442\u044F\u0436\u043A\u0438 <br/> \u0441&nbsp;\u0448\u0443\u043C\u043E\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0435\u0439"
    }, {
      id: 2,
      text: isMobile ? "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0433\u0438\u0434\u0440\u043E\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438 <br/> \u0432&nbsp;\u0421/\u0423, \u0441\u0442\u044F\u0436\u043A\u0438 \u0432&nbsp;\u0421/\u0423" : "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0433\u0438\u0434\u0440\u043E\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438 \u0432&nbsp;\u0421/\u0423,  <br/>\u0441\u0442\u044F\u0436\u043A\u0438 \u0432&nbsp;\u0421/\u0423"
    }, {
      id: 3,
      text: "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043C\u0435\u0445\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0432\u0435\u043D\u0442\u0438\u043B\u044F\u0446\u0438\u0438"
    }, {
      id: 4,
      text: "\u041C\u043E\u043D\u0442\u0430\u0436 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F, \u0441&nbsp;\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u043E\u0439 \u043F\u0440\u0438\u0431\u043E\u0440\u043E\u0432 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F"
    }, {
      id: 5,
      text: "\u041C\u043E\u043D\u0442\u0430\u0436 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u043D\u043E\u0433\u043E \u0449\u0438\u0442\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u044F"
    }, {
      id: 6,
      text: isMobile ? "\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0441\u0442\u0435\u043D \u043F\u043E\u0434 \u0444\u0438\u043D\u0438\u0448\u043D\u0443\u044E \u043E\u0442\u0434\u0435\u043B\u043A\u0443" : "\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0441\u0442\u0435\u043D \u043F\u043E\u0434 \u0444\u0438\u043D\u0438\u0448\u043D\u0443\u044E \u043E\u0442\u0434\u0435\u043B\u043A\u0443"
    }, {
      id: 7,
      text: "\u0412\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435 \u0441\u0442\u0435\u043D (\u043A\u0440\u043E\u043C\u0435 \u0421/\u0423)"
    }, {
      id: 8,
      text: isMobile ? "\u0412\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u043F\u0435\u0440\u0435\u0433\u043E\u0440\u043E\u0434\u043E\u043A \u043D\u0430&nbsp;\u0432\u0441\u044E \u0432\u044B\u0441\u043E\u0442\u0443 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F" : "\u0412\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u043F\u0435\u0440\u0435\u0433\u043E\u0440\u043E\u0434\u043E\u043A <br/>\u043D\u0430&nbsp;\u0432\u0441\u044E \u0432\u044B\u0441\u043E\u0442\u0443 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F"
    }, {
      id: 9,
      text: "\u041E\u0431\u0435\u0441\u043F\u044B\u043B\u0438\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0442\u043E\u043B\u043A\u0430"
    }, {
      id: 10,
      text: isMobile ? "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0442\u043E\u0447\u043A\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0434\u0440\u0435\u043D\u0430\u0436\u043D\u043E\u0439 <br/> \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0434\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u0431\u043B\u043E\u043A\u043E\u0432" : "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0442\u043E\u0447\u043A\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0434\u0440\u0435\u043D\u0430\u0436\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0434\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u0431\u043B\u043E\u043A\u043E\u0432"
    }, {
      id: 11,
      text: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0436\u0430\u0440\u043D\u043E\u0439 \u0441\u0438\u0433\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438"
    }, {
      id: 12,
      text: "\u0412\u0432\u043E\u0434 \u0444\u0440\u0435\u043E\u043D\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043E\u0432 \u043F\u043E\u0434 \u043A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0435\u0440"
    }, {
      id: 13,
      text: "\u0420\u0430\u0437\u0432\u043E\u0434\u043A\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u043A\u0438 \u043E\u0442&nbsp;\u043A\u0432\u0430\u0440\u0442\u0438\u0440\u043D\u043E\u0433\u043E \u0449\u0438\u0442\u0430 \u0434\u043E&nbsp;\u043C\u0435\u0441\u0442\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043F\u0440\u0438\u0431\u043E\u0440\u043E\u0432, \u0441&nbsp;\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u043E\u0439 \u043F\u043E\u0434\u0440\u043E\u0437\u0435\u0442\u043D\u0438\u043A\u043E\u0432"
    }];
    const columns = [finishingPoints.slice(0, 7), finishingPoints.slice(7)];
    t5 = style.wrapper;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className={style.imageBox}><ParallaxMedia className={style.image} src={whiteboxNew} name={"\u041F\u0440\u0435\u0434\u0447\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430"} imagePlug={whiteboxNew} height="100%" /><p className={style.imageDescription}>Предчистовая отделка</p></div>;
      t7 = <p className={style.title}>В отделку включено</p>;
      $[9] = t6;
      $[10] = t7;
    } else {
      t6 = $[9];
      t7 = $[10];
    }
    t2 = style.columns;
    t3 = Math.max(...columns.map(_temp));
    t4 = <ul className={style.column}>{columns[0].map(_temp2)}</ul>;
    t0 = style.column;
    t1 = columns[1].map(_temp3);
    $[0] = isMobile;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[11] !== t0 || $[12] !== t1) {
    t8 = <ul className={t0}>{t1}</ul>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t8) {
    t9 = <div className={t2} data-elements-length={t3}>{t4}{t8}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t10 = <div className={t5}>{t6}{t7}{t9}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
function _temp(column) {
  return column.length;
}
function _temp2(item) {
  return <li key={item.id} className={style.point}><span className={style.number}>{item.id}</span><SafeHtmlRenderer tag="span" className={style.text} content={item.text || ""} /></li>;
}
function _temp3(item_0) {
  return <li key={item_0.id} className={style.point}><div className={style.number}>{item_0.id}</div><SafeHtmlRenderer tag="span" className={style.text} content={item_0.text || ""} /></li>;
}